import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import axiosInstance from "../services/axios";
// import { UserHeader } from "../components/UserHeader";
import React from "react";
import UploadFormModal from "./UploadFormPage";
import styles from "./css/AnalystForms.module.css";
import { FormDto, Category } from "../types/category.types";
import { showError, showConfirm } from "../utils/notifications";
import { safeLogger } from "../utils/logger";
import {baseURL} from "../services/axios"

export const FormsPage = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const analystId = user?.code;
  
  console.log("מנתחת מחוברת:", user);
  console.log("מזהה המנתחת:", analystId);
  
  const [forms, setForms] = useState<FormDto[]>([]);
  const [filteredForms, setFilteredForms] = useState<FormDto[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [editFileName, setEditFileName] = useState<string>("");
  const [editFile, setEditFile] = useState<File | null>(null);
  const [editCategoryId, setEditCategoryId] = useState<number>(0);

  useEffect(() => {
    if (!analystId) return;
    fetchData();
  }, [analystId]);
  
  // פילטור הטפסים לפי מונח החיפוש
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredForms(forms);
    } else {
      const filtered = forms.filter(form => 
        form.FileName.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredForms(filtered);
    }
  }, [searchTerm, forms]);

  // --- END OF PATCHED CODE ---

  // כל קוד נוסף שנפגע מהדבקה קודמת הוסר

  const fetchData = async () => {
    try {
      setLoading(true);
      const [formsRes, categoriesRes] = await Promise.all([
        axiosInstance.get(`/Form`),
        axiosInstance.get(`/FormCategory`),
      ]);

      // Debug server response
      console.log("תשובת שרת - טפסים:", formsRes.data);
      console.log("דוגמה לטופס אחד:", formsRes.data.length > 0 ? formsRes.data[0] : "אין טפסים");
      console.log("מפתחות בטופס:", formsRes.data.length > 0 ? Object.keys(formsRes.data[0]) : "אין טפסים");
      console.log("תשובת שרת - קטגוריות:", categoriesRes.data);

      setCategories(categoriesRes.data);

      // Collect all keys for debug
      console.log("בדיקת מפתחות עבור כל הטפסים:");
      const allKeys = new Set<string>();
      formsRes.data.forEach((form: any, index: number) => {
        Object.keys(form).forEach(key => allKeys.add(key));
        console.log(`טופס ${index}: ${form.fileName || form.FileName || "ללא שם"} - מפתחות: ${Object.keys(form).join(", ")}`);
      });
      console.log("כל המפתחות שנמצאו:", Array.from(allKeys).join(", "));

      // Filter forms for current analyst
      const analystForms = formsRes.data.filter((form: any) => {
        const possibleAnalystFields = [
          "AnalystCode", "analystCode", "analystId", "AnalystId",
          "analystID", "AnalystID", "uploadedBy", "UploadedBy",
          "createdBy", "CreatedBy", "analyst_id"
        ];
        for (const field of possibleAnalystFields) {
          if (form[field] !== undefined) {
            const fieldValue = form[field];
            const isMatch = fieldValue === analystId ||
              fieldValue === Number(analystId) ||
              fieldValue === String(analystId);
            if (isMatch) {
              return true;
            }
          }
        }
        return false;
      });

      console.log(`נמצאו ${analystForms.length} טפסים עבור המנתחת עם מזהה ${analystId}`);
      if (analystForms.length > 0) {
        console.log("דוגמאות לטפסים שנמצאו:", analystForms.slice(0, 3).map((f: any) => f.fileName || f.FileName));
      }

      setForms(
        analystForms.map((form: any) => {
          let formCategoryId = form.FormCategoryId ?? form.formCategoryId ?? form.formCategoryCode ?? form.FormCategoryCode;
          if (typeof formCategoryId === "string") formCategoryId = Number(formCategoryId);
          const found = categoriesRes.data.find((c: Category) => c.code === formCategoryId);
          return {
            ...form,
            FormCategoryId: formCategoryId,
            CategoryName: found?.categoryName || form.categoryName || "",
            FileName: form.FileName || form.fileName || "",
            Id: form.Id || form.id
          };
        })
      );
    } catch (error) {
      showError("שגיאה בטעינת טפסים או קטגוריות");
  safeLogger.error("שגיאה ב-fetchData AnalystForms: " + error);
    } finally {
      setLoading(false);
    }
  };
  // Handlers for edit, save, cancel, delete, and upload
  const handleEdit = (index: number) => {
    setEditIndex(index);
    setEditCategoryId(filteredForms[index].FormCategoryId || 0);
    setEditFileName(filteredForms[index].FileName || "");
    setEditFile(null);
  };

  const handleCancelEdit = () => {
    setEditIndex(null);
    setEditFileName("");
    setEditFile(null);
    setEditCategoryId(0);
  };

  const handleSaveEdit = async (form: FormDto) => {
    if (editIndex === null) return;
    try {
      let updatedForm = { ...form, FormCategoryId: editCategoryId };
      if (editFile) {
        // If file is changed, upload new file
        const formData = new FormData();
        formData.append("Id", String(form.Id));
        formData.append("FileName", editFile.name);
        formData.append("FormCategoryId", String(editCategoryId));
        formData.append("File", editFile);
        await axiosInstance.put(`/Form/${form.Id}`, formData);
      } else {
        // Only update category
        await axiosInstance.put(`/Form/${form.Id}`, updatedForm);
      }
      showConfirm("הטופס עודכן בהצלחה");
      fetchData();
      handleCancelEdit();
    } catch (error) {
      showError("שגיאה בעדכון הטופס");
  safeLogger.error("שגיאה ב-handleSaveEdit AnalystForms: " + error);
    }
  };

  const handleDelete = async (id: number) => {
    if (!window.confirm("האם אתה בטוח שברצונך למחוק את הטופס?")) return;
    try {
      await axiosInstance.delete(`/Form/${id}`);
      showConfirm("הטופס נמחק בהצלחה");
      fetchData();
    } catch (error) {
      showError("שגיאה במחיקת הטופס");
  safeLogger.error("שגיאה ב-handleDelete AnalystForms: " + error);
    }
  };

  const handleFormUploaded = (newForm: FormDto) => {
    // Optionally, you can just refetch all data
    fetchData();
  };

  return (
    <div style={{
      backgroundImage: 'url("/Images/view1.png")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed',
      minHeight: '100vh',
      margin: 0,
      padding: 0
    }}>
      {/* <UserHeader /> */}
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.title}>
            הטפסים שלי
            <span className={styles.titleUnderline}></span>
          </div>
          
          {/* תיבת חיפוש */}
          <div className={styles.searchContainer}>
            <input
              type="text"
              placeholder="חיפוש לפי שם טופס..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
          </div>

          {/* טבלת הטפסים */}
          <div className={styles.tableContainer}>
            <table className={styles.table}>
              <thead>
                <tr className={styles.tableHeader}>
                  <th className={styles.tableHeaderCell}>שם הטופס</th>
                  <th className={styles.tableHeaderCell}>קטגוריה</th>
                  <th className={styles.tableHeaderCell}>צפייה</th>
                  <th className={styles.tableHeaderCell}>פעולות</th>
                </tr>
              </thead>
              <tbody>
                {filteredForms.length === 0 ? (
                  <tr>
                    <td colSpan={4} className={styles.noForms}>
                      {loading ? 'טוען טפסים...' : (
                        forms.length === 0 ? 
                          'אין טפסים זמינים למנתחת זו' : 
                          'לא נמצאו טפסים מתאימים לחיפוש'
                      )}
                    </td>
                  </tr>
                ) : (
                  filteredForms.map((f, i) => (
                    <tr key={i} className={styles.tableRow}>
                      <td className={styles.tableCell}>
                        {f.FileName}
                      </td>
                      <td className={styles.tableCell}>
                        {editIndex === i ? (
                          <select
                            value={editCategoryId}
                            onChange={e => setEditCategoryId(Number(e.target.value))}
                            className={styles.select}
                          >
                            <option value="">בחר קטגוריה</option>
                            {categories.map((c) => (
                              <option key={c.code} value={c.code}>
                                {c.categoryName}
                              </option>
                            ))}
                          </select>
                        ) : (
                          f.CategoryName || "ללא קטגוריה"
                        )}
                      </td>

                      <td className={styles.tableCell}>
                        <a
                           href={`${baseURL}/Form/${f.Id}/file`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={styles.viewLink}
                        >
                          לצפייה בטופס
                        </a>
                        {editIndex === i && (
                          <input
                            type="file"
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.odt,.csv,.zip,.rar,.7z,.xml,.json,.html,.md,.pages"
                            onChange={e => setEditFile(e.target.files?.[0] || null)}
                            className={styles.fileInput}
                          />
                        )}
                      </td>
                      <td className={styles.tableCell}>
                        {editIndex === i ? (
                          <>
                            <button 
                              onClick={() => handleSaveEdit(f)}
                              className={styles.saveButton}
                              title="שמור"
                            >
                              ✓
                            </button>
                            <button 
                              onClick={handleCancelEdit}
                              className={styles.cancelButton}
                              title="ביטול"
                            >
                              ✕
                            </button>
                          </>
                        ) : (
                          <>
                            <button 
                              onClick={() => handleEdit(i)}
                              className={styles.editButton}
                              title="ערוך"
                            >
                              ✏️
                            </button>
                            <button 
                              onClick={() => f.Id !== undefined ? handleDelete(f.Id) : null}
                              className={styles.deleteButton}
                              title="מחק"
                            >
                              🗑️
                            </button>
                          </>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* כפתור העלאת טופס חדש */}
        <div className={styles.addButtonContainer}>
          <button 
            onClick={() => (document.getElementById('uploadFormDialog') as HTMLDialogElement)?.showModal()} 
            className={styles.addButton}
          >
            <span>+</span> הוספת טופס
          </button>
        </div>

        {/* דיאלוג להעלאת טופס */}
        <dialog id="uploadFormDialog">
          <div>
            <button 
              className={styles.closeButton} 
              onClick={() => (document.getElementById('uploadFormDialog') as HTMLDialogElement)?.close()}
            >
              ✕
            </button>
            <UploadFormModal 
              onFormUploaded={(newForm: FormDto) => {
                handleFormUploaded(newForm);
                (document.getElementById('uploadFormDialog') as HTMLDialogElement)?.close();
              }} 
              isAnalyst={true} 
              analystId={analystId || 0} 
            />
          </div>
        </dialog>
      </div>
    </div>
  );
};
